import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { ArrowLeft } from 'lucide-react';

const TermsPage = () => {
  const navigate = useNavigate();
  return (
    <div className="min-h-dvh bg-background font-sans">
      <Helmet>
        <title>Términos y Condiciones | Museo de la Fe</title>
        <meta name="description" content="Términos y condiciones de uso de Museo de la Fe." />
        <link rel="canonical" href="https://museodelafe.com/terminos" />
      </Helmet>
      <Header />
      <div className="max-w-xl mx-auto px-6 pt-8 pb-20">
        <button onClick={() => navigate(-1)} className="flex items-center gap-1.5 text-sm text-muted-foreground hover:text-foreground transition-colors mb-6"><ArrowLeft className="size-4" /> Volver</button>
        <h1 className="text-2xl font-bold mb-6">Términos y Condiciones</h1>
        <div className="space-y-6 text-sm text-muted-foreground leading-relaxed">
          <p><strong className="text-foreground">Última actualización:</strong> Abril 2026</p>
          <section>
            <h2 className="text-base font-semibold text-foreground mb-2">1. Servicio</h2>
            <p>Museo de la Fe es una plataforma digital que ofrece libritos cristianos ilustrados para niños en formato flipbook interactivo. Al usar nuestro servicio, aceptas estos términos.</p>
          </section>
          <section>
            <h2 className="text-base font-semibold text-foreground mb-2">2. Cuentas</h2>
            <p>Para comprar libritos necesitas crear una cuenta mediante Google OAuth. Eres responsable de mantener la seguridad de tu cuenta. Una cuenta es personal e intransferible.</p>
          </section>
          <section>
            <h2 className="text-base font-semibold text-foreground mb-2">3. Compras y pagos</h2>
            <p>Los precios están expresados en USD. Los pagos se procesan a través de PayPal. Una vez completada la compra, el librito se agrega a tu biblioteca personal. Los pagos no son reembolsables salvo en casos excepcionales a discreción de Museo de la Fe.</p>
          </section>
          <section>
            <h2 className="text-base font-semibold text-foreground mb-2">4. Uso del contenido</h2>
            <p>Los libritos comprados son para uso personal. No está permitido copiar, distribuir, descargar ni compartir el contenido de los libritos fuera de la plataforma. La función de regalo permite compartir el acceso mediante un enlace único de un solo uso.</p>
          </section>
          <section>
            <h2 className="text-base font-semibold text-foreground mb-2">5. Propiedad intelectual</h2>
            <p>Todo el contenido de los libritos (ilustraciones, textos, diseños) es propiedad de Museo de la Fe. Queda prohibida su reproducción total o parcial sin autorización escrita.</p>
          </section>
          <section>
            <h2 className="text-base font-semibold text-foreground mb-2">6. Reseñas</h2>
            <p>Al dejar una reseña, otorgas a Museo de la Fe el derecho de usar tu nombre y comentario con fines promocionales. Las reseñas deben ser respetuosas y verídicas.</p>
          </section>
          <section>
            <h2 className="text-base font-semibold text-foreground mb-2">7. Disponibilidad</h2>
            <p>El servicio está disponible para usuarios en Latinoamérica y Estados Unidos. Nos reservamos el derecho de modificar, suspender o discontinuar el servicio con previo aviso.</p>
          </section>
          <section>
            <h2 className="text-base font-semibold text-foreground mb-2">8. Contacto</h2>
            <p>Para consultas sobre estos términos: <a href="mailto:admin@museodelafe.com" className="text-foreground hover:underline">admin@museodelafe.com</a></p>
          </section>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default TermsPage;
